import { isTeamContextHandled } from "../../teamContext/teamSwitchService";
import React, { useState, useEffect } from "react";
import { Button, IconButton } from "../../design_system/components/Button/Button.jsx";
import { Popup } from "../../design_system/components/Popup/Popup.jsx";
import { Tooltip } from "../../design_system/components/ToolTip/ToolTip.jsx";
import { Icons } from "../../design_system/components/Icons";
import { Badge } from "../../design_system/components/Input Fields/Badge.jsx";
import { InputArea } from "../../design_system/components/Input Fields/InputArea.jsx";
import { useToast } from "../../design_system/components/Toast/ToastContext.jsx";
import { apiAgent } from "../../axiosConfig.js";
import AnMultipleSuggestionInputBox from "../input_utils/AnMultipleSuggestionBox.js";
import Avatar from "../../design_system/components/Avatar/Avatar.jsx";
import { Link } from "react-router-dom";
import { TextHighlighter } from "../utils/textHighlighter.js";
import { useSelector } from "react-redux";
import { MENTION_TYPES } from "../utils/AllMentionTypes";
import ConditionalRender from "../../ConditionalRender.js";
import { indexOfObject } from "../utils/ArrayUtils.js";
import Seemore from "../utils/SeemoreUtils.js";
import useCheckUserAccess from "../custom_hooks/useCheckUserAccess.js";
import SelectPublishPopup from "../cta_utils/CommonPopups.js/PublishPopups/SelectPublishPopup.jsx";
import getApiUrl from "../utils/UrlHelper.js";
import AiSummaryBox from "./AiSummaryBox.jsx";
import { SimilarArticlesPopup } from "../views/news_feed/similar_articles.js";
import { handleNewsImageError } from "../utils/newsImageFallback.js";
import { canPublishFeedType } from "../../utils/access.js";

const descTypes = [{ label: 'Description', key: 'description' }, { label: "Smart Description", key: 'smart_description' }];
const LowConfidencePost = ({
    renderPostHeader = true,
    renderParentType = "default",
    confidenceType,
    ...props }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [currentAggregate, setCurrentAggregate] = useState();
    const [popupsList, setPopupsList] = useState({});
    const [mentionType, setMentionType] = useState("");
    const [flaggedReason, setFlaggedReason] = useState("");
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [interests, setInterests] = useState("");
    const toast = useToast();
    const current_user = useSelector(state => state.current_user?.user);
    const current_team = useSelector(state => state.current_team?.team);
    const [descType, setDescType] = useState("description");
    const [descTabType, setDescTabType] = useState("description");
    const [smartDesc, setSmartDesc] = useState("");

    const checkUserAccess = useCheckUserAccess();
    const articlePostType = currentAggregate?.post_type;
    const canPublishArticle = canPublishFeedType({ postType: articlePostType, user: current_user, team: current_team });
    useEffect(() => {
        // Background query refreshes can replace an article without changing its ID.
        setCurrentAggregate(props.item);
        const index = indexOfObject(MENTION_TYPES, "text", props.item.mentioned_for);
        setMentionType(MENTION_TYPES[index]?.value || "");
    }, [props.item]);

    const showPublishPopup = () => {
        var prospects = currentAggregate.news_query.prospects;
        if (prospects) setSelectedOptions(prospects);
        setPopupsList({ ...popupsList, publishPopup: true });
    };

    const flagAggregate = (article_id) => {
        setIsLoading(true);
        apiAgent({
            method: "post",
            url: "/aggregate/" + article_id + "/flag",
            data: {
                flagged_reason: flaggedReason,
                tab_type: props.tabType,
                check_pub_guideline_ack: !!props.checkGuidelineAcknowledgement
            },
        }).then(
            (response) => {
                const newAggregate = {
                    ...currentAggregate,
                    flagged_at: response.data.flagged_at,
                    flagged_by: response.data.flagged_by,
                    flagged_reason: response.data.flagged_reason,
                };
                setCurrentAggregate(newAggregate);
                toast.success("Article Flagged")
            },
            (error) => {
                if (isTeamContextHandled(error)) return;
                if (error.response?.data?.error === 'ack_failed') props.renderGuidelinesUpdateWarning(error.response.data.data);
                else toast.warning(error?.response?.data?.error)
            },
        ).finally(() => {
            setIsLoading(false);
            setPopupsList({ ...popupsList, flagPopup: false });
            setFlaggedReason("");
        })
    }

    const onSavePublishedCallback = (newAggregateData, response = {}) => {
        handlePublishPopupClose();
        setIsLoading(false);
        setCurrentAggregate({ ...currentAggregate, published: true });
        props.item.published = true;
        props.callbacks?.onPublishCallback?.(currentAggregate, "published")
    }

    const discardSearchTerm = () => {
        setIsLoading(true);
        apiAgent({
            method: "post",
            url: "/aggregates/" + currentAggregate.id + "/discard_search_term",
            data: { check_pub_guideline_ack: !!props.checkGuidelineAcknowledgement },
        }).then(res => {
            setIsLoading(false);
            setPopupsList(prev => ({ ...prev, discardSearchTermPopup: false }));
            setCurrentAggregate({ ...currentAggregate, discarded: true });
            props.callbacks?.onDiscardCallback?.(currentAggregate, "discarded")
        }).catch(err => {
            setIsLoading(false);
            if (err.response?.data?.error === 'ack_failed') props.renderGuidelinesUpdateWarning(err.response.data.data);
        })
    }

    const handlePublishPopupClose = () => {
        setPopupsList({ ...popupsList, publishPopup: false });
    };

    const setArticleData = (key, value) => {
        var tempArticle = { ...currentAggregate.sharable_article };
        tempArticle[key] = value;
        setCurrentAggregate({
            ...currentAggregate,
            sharable_article: tempArticle,
        });
    };
    const setCurrentAggregateState = (payload) => setCurrentAggregate({ ...currentAggregate, ...payload })
    const fetch_smart_desc = () => {
        let dataParams = { ...currentAggregate.sharable_article };
        if (!dataParams.description) return;
        apiAgent({
            method: 'get',
            url: "/aggregates/" + currentAggregate.id + "/fetch_smart_desc",
            params: {}
        }).then(res => {
            setSmartDesc(res.data.data);
        }).catch(err => {

        })
    }

    const getDescription = () => {
        return descType == 'description' ? currentAggregate.sharable_article.description : smartDesc
    }

    const flagPopup = () => {
        return (
            <Popup
                name="Flag Post"
                handleOnClosePopup={() => { setFlaggedReason(""); setPopupsList({ ...popupsList, flagPopup: false }) }}
                maxWidth={408}
                customContentStyle={{ padding: 0 }}
                primaryAction={{ label: "Submit", onClick: () => flagAggregate(currentAggregate.id), isLoading, disabled: flaggedReason.length === 0 }}
                secondaryAction={{ label: "Cancel", onClick: () => { setFlaggedReason(""); setPopupsList({ ...popupsList, flagPopup: false }) } }}
            >
                <div className="newsfeed__flag-popup-body">
                    <InputArea
                        label="Reason"
                        showLabel
                        value={flaggedReason || ""}
                        handleOnChange={(e) => setFlaggedReason(e.target.value)}
                        placeholder="Please mention the reason"
                        rows={4}
                    />
                </div>
            </Popup>
        );
    }

    const renderProspect = () => {
        var name = currentAggregate.news_query.person_name;
        var designation = currentAggregate.news_query.company_name;
        let prospect_id = "";
        let prospect = {};
        // On the published tab, show the post's actual tagged prospect so edits via
        // update_description are reflected (falls back to the news query's prospects).
        const publishedProspects = props.tabType === "published" ? currentAggregate.published_posts?.[0]?.tagged_prospects : null;
        const displayProspects = (publishedProspects && publishedProspects.length > 0) ? publishedProspects : currentAggregate.news_query.prospects;
        if (displayProspects && displayProspects.length > 0) {
            name = displayProspects[0].name || displayProspects[0].company;
            designation = displayProspects[0].designation;
            if (!displayProspects[0].name)
                designation = "";
            prospect_id = displayProspects[0].id;
            prospect = displayProspects[0] || {};
        }
        return (
            <>
                <div className="flex justify-between items-center gap-m mx-xl">
                    <a {...prospect_id ? { href: `/prospects/${prospect_id}` } : {}} className="flex items-center min-w-0 no-underline no-margin-top newsfeed__prospect-container newsfeed__prospect-container--link">
                        <div className="newsfeed__prospect-info">
                            <Avatar
                                width={40}
                                name={name}
                                profile_image={prospect.profile_image}
                            />
                            <div className="flex flex-col flex-1 min-w-0">
                                <div className="body-m-bold block no-underline newsfeed__post-title">{name}</div>
                                <ConditionalRender if={designation}>
                                    <Tooltip
                                        tooltipText={() => designation}
                                        placement='bottom'
                                    >
                                        <div className="body-s-semibold newsfeed__item-subtitle truncate newsfeed__item-subtitle--padded-right">
                                            {designation}
                                        </div>
                                    </Tooltip>
                                </ConditionalRender>
                            </div>
                        </div>
                    </a>
                    <div className="flex items-center flex-row gap-s flex-shrink-0">
                        {props.headerExtra}
                        <ConditionalRender if={canPublishArticle && !currentAggregate.published}>
                            <Button
                                onClick={() => showPublishPopup()}
                                Size="Small"
                            >
                                Move to High Confidence
                            </Button>
                        </ConditionalRender>
                        {
                            props.admin && (
                                <>
                                    {currentAggregate.published_posts?.[0]?.publisher_name && (
                                        <span className="body-s-semibold newsfeed__item-subtitle no-margin-top">
                                            Published by <span className="body-m-bold newsfeed__post-title"> {currentAggregate.published_posts?.[0]?.publisher_name} </span>
                                        </span>
                                    )}
                                    {props.tabType === "published" && (
                                        <Tooltip tooltipText="Edit post" placement="bottom" showWithoutOverflowing>
                                            <IconButton Type="Tertiary" Size="Small" IconName="pencil" ariaLabel="Edit post"
                                                onClick={() => {
                                                    const hasMultiplePosts = (currentAggregate.published_posts || []).length > 1;
                                                    setPopupsList(prev => ({ ...prev, [hasMultiplePosts ? "multiPostInfoPopup" : "editPostPopup"]: true }));
                                                }}
                                            />
                                        </Tooltip>
                                    )}
                                    <Tooltip tooltipText="Copy link" placement="bottom" showWithoutOverflowing>
                                        <IconButton Type="Tertiary" Size="Small" IconName="share" ariaLabel="Copy link"
                                            onClick={() => { navigator.clipboard.writeText(window.location.href + '?smart_id=' + currentAggregate.id + '&tab_type=' + props.tabType); toast.success("Post link copied") }}
                                        />
                                    </Tooltip>
                                    <Tooltip tooltipText="Flag post" placement="bottom-end" showWithoutOverflowing>
                                        <IconButton Type="Tertiary" Size="Small" IconName="flag" ariaLabel="Flag post"
                                            IsSelected={!!currentAggregate.flagged_at}
                                            onClick={() => setPopupsList({ ...popupsList, flagPopup: true })}
                                        />
                                    </Tooltip>
                                </>
                            )
                        }
                    </div>
                </div>
                <div className="newsfeed__divider mt-m"></div>
            </>
        );
    };
    if (!currentAggregate) return <div></div>;
    else if ((currentAggregate.published || currentAggregate.discarded) && !props.singleArticle)
        return <div></div>;
    else {
        const firstPublishedPost = props.tabType === "published" ? currentAggregate.published_posts?.[0] : null;
        // Published tab shows the POST's own content; sharable_article stays matching-article data, post data lives in published_posts.
        const cardArticle = firstPublishedPost
            ? {
                ...currentAggregate.sharable_article,
                title: firstPublishedPost.title ?? currentAggregate.sharable_article.title,
                short_description: firstPublishedPost.short_description ?? currentAggregate.sharable_article.short_description,
                description: firstPublishedPost.description ?? currentAggregate.sharable_article.description,
            }
            : currentAggregate.sharable_article;
        const cardDate = firstPublishedPost?.published_at || currentAggregate.aggregated_date;
        return (
            <div>
                <div className="newsfeed__post-card">
                    <ConditionalRender if={renderPostHeader}>
                        {renderProspect()}
                    </ConditionalRender>
                    <ConditionalRender if={articlePostType !== 'Post::SecFiling' && (firstPublishedPost?.mentioned_for || firstPublishedPost?.interests)}>
                        <div className="flex items-center gap-m newsfeed__post-meta-row color-text-secondary body-m-semibold mt-m mx-xl">
                            <ConditionalRender if={firstPublishedPost?.mentioned_for}>
                                <span>Mentioned for: <span className="color-text-primary">{firstPublishedPost?.mentioned_for}</span></span>
                            </ConditionalRender>
                            <ConditionalRender if={firstPublishedPost?.mentioned_for && firstPublishedPost?.interests}>
                                <span aria-hidden="true" className="color-text-tertiary">·</span>
                            </ConditionalRender>
                            <ConditionalRender if={firstPublishedPost?.interests}>
                                <span>{firstPublishedPost?.interests}</span>
                            </ConditionalRender>
                        </div>
                    </ConditionalRender>
                    <ConditionalRender if={articlePostType === 'Post::SecFiling'}>
                        <div className="mx-xl mt-m flex flex-col gap-xs">
                            {currentAggregate.sec_category && <div className='body-s-semibold color-text-secondary'><span className="body-s-bold">Category:</span><span> {currentAggregate.sec_category}</span> </div>}
                            {currentAggregate.ai_summary && <div><AiSummaryBox aiSummary={currentAggregate.ai_summary} /></div>}
                        </div>
                    </ConditionalRender>
                    <a
                        href={cardArticle.url}
                        className="newsfeed__post-body mx-xl"
                        target="_blank"
                    >
                        {cardArticle.image_url &&
                            <img
                                src={
                                    cardArticle.image_url
                                }
                                className={props.imageClass || "newsfeed__post-image"}
                                onError={handleNewsImageError}
                            />
                        }
                        <div className="overflow-hidden">
                            <TextHighlighter
                                contentString={
                                    cardArticle.title
                                }
                                toMatch={
                                    currentAggregate.news_query.person_name
                                }
                                typography={{ className: "block no-underline newsfeed__post-title body-m-bold" }}
                                style={{ marginBottom: 4 }}
                            />
                            <ConditionalRender if={cardArticle.source !== 'sec.gov'}>
                                <Seemore
                                    short_description={cardArticle.short_description}
                                    description={cardArticle.description}
                                    person_name={currentAggregate.news_query.person_name}
                                >
                                </Seemore>
                            </ConditionalRender>
                            {/* <div className="text_body_light">{currentAggregate.sharable_article.description}</div> */}
                            <div className="support-m color-text-secondary mt-s">
                                <Link to={"/news_source/" + cardArticle.source + "/feed"} className="link-default newsfeed__link support-m">{cardArticle.source}</Link> | {" "}
                                {cardDate}
                                {current_user.is_super_admin && (
                                    <React.Fragment>
                                        {" "} | {" "}
                                        {
                                            (currentAggregate.media_score > 0) && (<span>Media Score: {currentAggregate.media_score + " | "}</span>)
                                        }
                                        <span className="newsfeed__post-source-links">
                                            {cardArticle.rss_sources.map(source => (
                                                <a href={source.url} target="_blank" rel="noopener noreferrer" className="link-default support-m newsfeed__link newsfeed__link--spaced-right">{source.host}</a>
                                            ))}
                                        </span>
                                    </React.Fragment>
                                )
                                }
                                {renderParentType === 'smart' && currentAggregate.sharable_article.is_published_at_inaccurate && <Badge type="Error" label="Not accurate" fontClass="support-m" customStyle={{ borderRadius: 'var(--radius-pill)', marginLeft: 'var(--space-s)', paddingTop: 2, paddingBottom: 2 }} />}
                                {renderParentType === 'smart' && currentAggregate.is_article_outdated && !currentAggregate.sharable_article.is_published_at_inaccurate && <Badge type="Error" label="Old article" fontClass="support-m" customStyle={{ borderRadius: 'var(--radius-pill)', marginLeft: 'var(--space-s)', paddingTop: 2, paddingBottom: 2 }} />}
                            </div>
                        </div>
                    </a>
                    {((currentAggregate.similar_articles_text && currentAggregate.similar_articles_text !== "") || props.admin) && (
                        <div className={`mx-xl flex items-center mt-m ${(currentAggregate.similar_articles_text && currentAggregate.similar_articles_text !== "") ? "justify-between" : "justify-end"}`}>
                            {currentAggregate.similar_articles_text &&
                                currentAggregate.similar_articles_text != "" && (
                                    <div>
                                        <div className="body-s-semibold color-text-secondary">
                                            Also featured in{" "}
                                            {currentAggregate.similar_articles_text}{" "}
                                            <button
                                                type="button"
                                                className="body-s-semibold link-default"
                                                onClick={() => setPopupsList({ ...popupsList, showSimilarArticles: true })}
                                                style={{ background: 'none', border: 0, padding: 0, cursor: 'pointer', font: 'inherit' }}
                                            >
                                                View articles
                                            </button>
                                        </div>
                                    </div>
                                )}
                            {props.admin && (<div className="body-s-semibold color-text-secondary text-right">last published at: {" "}
                                {
                                    currentAggregate.news_query.prospects &&
                                    currentAggregate.news_query.prospects.length > 0 && (
                                        <Link
                                            to={
                                                "/prospects/" + currentAggregate.news_query.prospects[0].id + "?tabType=feed"
                                            }
                                            className="link-default body-s-bold newsfeed__link"
                                        >
                                            {currentAggregate.news_query.prospects[0].last_published_date}
                                        </Link>
                                    )}
                            </div>)}
                        </div>
                    )}
                    {popupsList.showSimilarArticles && (
                        <SimilarArticlesPopup
                            articleId={currentAggregate.id}
                            masterArticle={{
                                ...cardArticle,
                                created_date: cardDate,
                            }}
                            prospectName={currentAggregate.news_query?.person_name}
                            onClose={() => setPopupsList({ ...popupsList, showSimilarArticles: false })}
                        />
                    )}
                    {
                        props.admin && (
                            <div className="mt-m mx-xl" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'var(--color-surface-subtle)', borderRadius: 'var(--radius-xs)', padding: 'var(--space-xs) var(--space-l)' }}>
                                <span className="body-m-semibold color-text-primary">{currentAggregate.news_query.person_name} - {currentAggregate.news_query.company_name}</span>
                                <span className="link-danger body-s-bold" onClick={() => setPopupsList(prev => ({ ...prev, discardSearchTermPopup: true }))}>Discard Search term</span>
                            </div>
                        )
                    }
                    <div className="clear-both"></div>
                    <ConditionalRender if={checkUserAccess('display_omf_tags')}>
                        <div className="newsfeed__divider my-m mx-0"></div>
                        <div className="flex items-center flex-wrap newsfeed__post-omf-tags mx-xl" style={{ columnGap: 'var(--space-s)', rowGap: 'var(--space-m)' }}>
                            {currentAggregate.matching_article_score && (
                                <Badge type="News" label={`Score: ${currentAggregate.matching_article_score}`} fontClass="support-m-semibold" customStyle={{ borderRadius: 'var(--radius-pill)', border: '0.5px solid var(--color-pill-news-border)' }} />
                            )}
                            {currentAggregate.matching_article_tags && Object.keys(currentAggregate.matching_article_tags || {}).map(k => (
                                <Tooltip key={k} showWithoutOverflowing placement="bottom" tooltipText={currentAggregate.matching_article_tags[k]}>
                                    <span className="newsfeed__tag-pill support-m-semibold">{k}</span>
                                </Tooltip>
                            ))}
                        </div>
                    </ConditionalRender>
                    {popupsList.publishPopup && (
                        <SelectPublishPopup
                            post_type={articlePostType}
                            source="low_confidence_feed"
                            onCloseCallback={handlePublishPopupClose}
                            aggregateData={{
                                prospects: currentAggregate.news_query.prospects,
                                mentioned_for: currentAggregate.mentioned_for,
                                sharable_article: { ...currentAggregate.sharable_article, published_at: currentAggregate.aggregated_date },
                            }}
                            onPublishCallback={onSavePublishedCallback}
                            mode="publish"
                            publish_url={getApiUrl("aggregate_publish", { ":id": currentAggregate.id })}
                            checkGuidelineAcknowledgement={props.checkGuidelineAcknowledgement}
                            renderGuidelinesUpdateWarning={props.renderGuidelinesUpdateWarning}
                        />
                    )}
                    {popupsList.editPostPopup && <SelectPublishPopup
                        post_type={articlePostType}
                        source="low_confidence_feed"
                        labels={{ popupName: "Edit Post", submitBtn: "Edit Post" }}
                        onCloseCallback={() => setPopupsList(prev => ({ ...prev, editPostPopup: false }))}
                        aggregateData={{
                            prospects: firstPublishedPost?.tagged_prospects || currentAggregate.news_query.prospects,
                            sharable_article: {
                                ...currentAggregate.sharable_article,
                                title: firstPublishedPost?.title,
                                short_description: firstPublishedPost?.short_description,
                                description: firstPublishedPost?.description,
                                published_at: firstPublishedPost?.published_at,
                            },
                            mentioned_for: firstPublishedPost?.mentioned_for || currentAggregate.mentioned_for
                        }}
                        onPublishCallback={(newData, response) => {
                            setPopupsList(prev => ({ ...prev, editPostPopup: false }));
                            // update_description returns the saved post (json/post) — map it back into published_posts[0]; post data is kept separate from the matching-article fields.
                            // NOTE: response.id is the POST id; never overwrite currentAggregate.id (the matching-article id).
                            const post = response || {};
                            const postSharedLink = post.shared_link || {};
                            setCurrentAggregate(prev => ({
                                ...prev,
                                published_posts: (prev.published_posts || []).map((p, idx) => idx === 0 ? {
                                    ...p,
                                    title: postSharedLink.title ?? p.title,
                                    short_description: postSharedLink.short_description ?? p.short_description,
                                    description: postSharedLink.description ?? p.description,
                                    published_at: postSharedLink.published_at || p.published_at,
                                    mentioned_for: post.mentioned_for ?? p.mentioned_for,
                                    tagged_prospects: post.tagged_prospects || p.tagged_prospects,
                                } : p),
                            }));
                            toast.success("Post saved successfully");
                        }}
                        mode="edit"
                        publish_url={getApiUrl("update_post", { ":id": firstPublishedPost?.id })}
                    />}
                    {popupsList.multiPostInfoPopup && (
                        <Popup
                            name="Multiple posts"
                            handleOnClosePopup={() => setPopupsList(prev => ({ ...prev, multiPostInfoPopup: false }))}
                            maxWidth="440px"
                            showHeaderDivider={false}
                            showFooterDivider={false}
                            primaryAction={{ label: "Got it", onClick: () => setPopupsList(prev => ({ ...prev, multiPostInfoPopup: false })) }}
                        >
                            <div className="body-m color-text-secondary">
                                This article is published to multiple prospects, so it has more than one post. Editing is not supported here — please edit the post from the feed instead.
                            </div>
                        </Popup>
                    )}
                    {popupsList.flagPopup && flagPopup()}
                    {popupsList.discardSearchTermPopup && (
                        <Popup
                            name="Discard Search Term"
                            handleOnClosePopup={() => setPopupsList(prev => ({ ...prev, discardSearchTermPopup: false }))}
                            maxWidth="440px"
                            showHeaderDivider={false}
                            showFooterDivider={false}
                            primaryAction={{ label: "Discard", onClick: discardSearchTerm, isLoading, Type: "Danger" }}
                            secondaryAction={{ label: "Cancel", onClick: () => setPopupsList(prev => ({ ...prev, discardSearchTermPopup: false })) }}
                        >
                            <div className="body-l-semibold">
                                Are you sure you want to discard this search term?
                            </div>
                        </Popup>
                    )}
                </div>
            </div>
        );
    }
};


export default LowConfidencePost;
